import { defineStore } from 'pinia'
import { ref } from 'vue'

/**
 * 全局应用级状态占位；后续可扩展主题、语言、用户会话等。
 */
export const useAppStore = defineStore('app', () => {
  const appName = ref(import.meta.env.VITE_APP_TITLE)

  /**
   * 编辑器撤销栈最大深度（全局可改，默认 30）。
   */
  const editorHistoryMaxSteps = ref(30)

  /**
   * @param n - 正整数上限；非法时回退为 30
   */
  function setEditorHistoryMaxSteps(n: number): void {
    const v = Math.round(Number(n))
    editorHistoryMaxSteps.value = Number.isFinite(v) && v >= 1 ? Math.min(500, v) : 30
  }

  return { appName, editorHistoryMaxSteps, setEditorHistoryMaxSteps }
})
